import { ImpressionSentEvent } from 'common/event-handling/events';
import eventBus from 'common/event-handling/event-bus.model';
import { FrameLifecycleService } from 'common/services/frame-lifecycle.service';

export class FrameLifecycleHandler {
  constructor() {
    this.handle();
  }

  handle() {
    const frameLifecycleService = new FrameLifecycleService();
    frameLifecycleService.listen();

    eventBus.subscribe(ImpressionSentEvent, () => {
      frameLifecycleService.destroy();
    });
  }
}
